export function setCookie(name, value, days = 1) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)

  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`
}

export function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}

export function deleteCookie(name) {
  document.cookie = `${name}=; Max-Age=0; path=/`
}
